export default __webpack_public_path__ + "static/media/googlePlay.ddc13dfc.png";